const modal = {
  namespaced: true,
  state: {
    isOpen: false,
    title: '',
    message: '',
    type: '',
    onCancel: () => {},
    onOK: () => {},
    params: {},
    renderType: '',
    availableInputs: [],
    isConfirmed: false,
    confirmMethod: null,
    subMessage: ''
  },
  mutations: {
    setIsOpen: (state, bool) => {
      state.isOpen = bool
    },
    setType: (state, type) => {
      state.type = type
    },
    setTitle: (state, title) => {
      state.title = title
    },
    setMessage: (state, message) => {
      state.message = message
    },
    setOnCancel: (state, onCancel) => {
      state.onCancel = onCancel
    },
    setOnOK: (state, onOK) => {
      state.onOK = onOK
    },
    setParams: (state, params) => {
      state.params = params
    },
    setRenderType: (state, renderType) => {
      state.renderType = renderType
    },

    setIsConfirmed: (state, bool) => {
      state.isConfirmed = bool
    },
    setConfirmMethod: (state, method) => {
      state.confirmMethod = method
    },
    setAvailableInputs: (state, availableInputs) => {
      state.availableInputs = availableInputs
    },

    setSubMessage: (state, subMessage) => {
      state.subMessage = subMessage
    }
  },
  getters: {
    getConfirmMessage: state => () => state.confirmMessage,
    isConfirmed: state => () => state.isConfirmed,
    getConfirmMethod: state => () => state.confirmMethod,

    type: state => state.type,
    isOpen: state => state.isOpen,
    title: state => state.title,
    message: state => state.message,
    subMessage: state => state.subMessage,
    functions: state => ({
      onOK: state.onOK,
      onCancel: state.onCancel
    }),
    params: state => state.params,
    renderType: state => state.renderType,
    availableInputs: state => state.availableInputs
  },
  actions: {
    open({
      commit
    }, {
      title = '',
      type,
      message,
      subMessage,
      onCancel = () => {},
      onOK = () => {},
      renderType = 'normal',
      params = {},
      availableInputs = []
    }) {
      commit('setTitle', title)
      commit('setMessage', message)
      commit('setType', type)
      commit('setOnOK', onOK)
      commit('setOnCancel', onCancel)
      commit('setRenderType', renderType)
      commit('setParams', params)
      commit('setAvailableInputs', availableInputs)
      commit('setIsOpen', true)
      commit('setSubMessage', subMessage)
    },

    close({
      commit
    }) {
      // commit('setMessage', '')
      // commit('setType', 'Confirm')
      // commit('setOnOK', () => {})
      // commit('setOnCancel', () => {})
      // commit('setRenderType', 'normal')
      // commit('setParams', {})
      commit('setAvailableInputs', [])
      commit('setIsOpen', false)
    }
  }
}

export default modal
